import React, { useState, useMemo, useEffect } from "react";
import CustomDataGenerationPage from "../CustomDataGenerationPage";
import CustomDataInputPage from "../CustomDataInputPage";
import styles from "./index.module.scss";
import WarningModal from "./WarningModal";
import queryString from "query-string";

const STEPS = {
    "INPUT": "INPUT",
    "GENERATE": "GENERATE",
}

// function CustomDataPage() {
//     const [step, setStep] = useState(STEPS.INPUT);
//     const [chartSpec, setChartSpec] = useState({
//         step1Question: null,
//         step2Question: null,
//         step3Question: null,
//         chartType: null,
//     });
function CustomDataPage() {
    // 檢查URL參數來決定初始狀態
    const getInitialState = () => {
        const urlParams = queryString.parse(window.location.search);
        const isGenerationPage = window.location.pathname === '/statistics/ChishangEarthquake/custom-data-generation';
        
        if (isGenerationPage && urlParams.title1ID && urlParams.chartType) {
            return {
                step: STEPS.GENERATE,
                chartSpec: {
                    step1Question: { Qid: urlParams.title1ID },
                    step2Question: urlParams.title2ID ? { Qid: urlParams.title2ID } : null,
                    step3Question: urlParams.title3ID ? { Qid: urlParams.title3ID } : null,
                    chartType: parseInt(urlParams.chartType),
                }
            };
        }
        
        return {
            step: STEPS.INPUT,
            chartSpec: {
                step1Question: null,
                step2Question: null,
                step3Question: null,
                chartType: null,
            }
        };
    };

    const initialState = getInitialState();
    const [step, setStep] = useState(initialState.step);
    const [chartSpec, setChartSpec] = useState(initialState.chartSpec);

    const handleSubmit = (chartSpec) => {
        setChartSpec(chartSpec);

        setStep(STEPS.GENERATE);

        // update browser history
        window.history.pushState({}, "", "/statistics/ChishangEarthquake/custom-data-generation");
    }

    useEffect(() => {
        // scroll to top
        window.scrollTo(0, 0);

    }, [step]);

    useEffect(() => {

        // 監聽瀏覽器的前進/後退按鈕
        const handlePopState = () => {
            // 根據當前URL判斷要顯示哪個步驟
            if (window.location.pathname === '/statistics/ChishangEarthquake/custom-data-generation') {
                setStep(STEPS.GENERATE);
            } else {
                setStep(STEPS.INPUT);
            }
        };


        window.addEventListener('popstate', handlePopState);

        // 清理監聽器
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    function handleBackBtnClicked(){
        // update browser history
        window.history.pushState({}, "", "/statistics/ChishangEarthquake/custom-data");
        setStep(STEPS.INPUT);
    }

    return (
        <div>
            <WarningModal />
            <div className={`${styles.page} ${step === STEPS.INPUT ? styles.active : ""}`}>
                <CustomDataInputPage
                    chartSpec={chartSpec}
                    onSubmit={handleSubmit}
                />
            </div>
            <div key={step} className={`${styles.page} ${step === STEPS.GENERATE ? styles.active : ""}`}>
                <CustomDataGenerationPage
                    chartSpec={chartSpec}
                    onBackBtnClicked={handleBackBtnClicked}
                />
            </div>
        </div>
    );

}

export default CustomDataPage;